// client/src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { retourVers } from '../utils/destination-connexion';
import axios from 'axios';
/**
 * Composant de route protégée
 * Utilisé pour protéger les routes qui nécessitent une authentification
 * Utilise le contexte d'authentification pour vérifier si l'utilisateur est connecté
 */
const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Si le chargement est en cours, afficher un indicateur de chargement
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="p-8 bg-white rounded-lg shadow-md text-center">
          <div className="animate-spin h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-700">Chargement...</p>
        </div>
      </div>
    );
  }

  // Non authentifié : vers la connexion, EN RETENANT la page demandée. Sans cet état, le login
  // choisissait selon le seul rôle — le guichet (`/counter`) d'un admin rouvrait sur `/manage`.
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={retourVers(location)} />;
  }

  // Si des rôles sont spécifiés, vérifier si l'utilisateur a un rôle autorisé
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  // Si l'utilisateur est authentifié et a le rôle requis, afficher le contenu de la route
  return <Outlet />;
};

export default ProtectedRoute;
